export const APPLICANT_ROLE = "applicant";

export const RECRUITER_ROLE = "recruiter";

export const ADMIN_ROLE = "admin";
